import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Utils } from '../../utils';
import { environment } from 'src/environments/environment';


@Injectable({
    providedIn: 'root'
})
export class ReturnsService {
    constructor(
        private http: HttpClient
    ) { }

    getReturns(data){
        return this.http.post(`${environment.apiUrl}/returns/getreturns`, data, 
        {
            headers: new HttpHeaders({
            "Content-Type": "application/json"
        })});
    }

    getReturnsItems(returnId:number){
        return this.http.get<any[]>(`${environment.apiUrl}/returns/getreturnitems/${returnId}`); 
    }

    cancelReturn(returnId:number){
        return this.http.post(`${environment.apiUrl}/returns/cancel/${returnId}`, {}, 
        {
            headers: new HttpHeaders({
            "Content-Type": "application/json"
        })});
    }

    confirmReturn(data){
        return this.http.post(`${environment.apiUrl}/returns/confirm/`, data, 
        {
            headers: new HttpHeaders({
            "Content-Type": "application/json"
        })});
    }

    getReturnRequest(id){
        return this.http.get<any[]>(`${environment.apiUrl}/returns/getreturnrequest/${id}`); 
    }
}